// 学习档案与素材分类共用的取值，顺序与后端 material_level_service / material_topic_service 一致
export const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2']
export const MATERIAL_TOPICS = [
  'daily-life', 'travel', 'food', 'work', 'business', 'tech', 'science', 'news',
  'culture', 'history', 'stories', 'health', 'sports', 'psychology', 'study'
]
export const LEARNING_GOALS = ['conversation', 'media', 'work', 'abroad', 'exam']

// quick 是首次引导里的听力快测，test 是完整定级测试
export const LEVEL_SOURCES = ['self', 'quick', 'test']
export const ONBOARDING_STEPS = ['goals', 'interests', 'listening', 'speaking']

const pickLevel = value => (CEFR_LEVELS.includes(value) ? value : null)
const pickSource = (value, level) => (level ? (LEVEL_SOURCES.includes(value) ? value : 'self') : null)
const pickList = (values, allowed) => (Array.isArray(values) ? [...new Set(values)].filter(value => allowed.includes(value)) : [])

export function normalizeProfile(raw) {
  const profile = raw || {}
  const listeningLevel = pickLevel(profile.listeningLevel)
  const speakingLevel = pickLevel(profile.speakingLevel)
  return {
    listeningLevel,
    listeningSource: pickSource(profile.listeningSource, listeningLevel),
    speakingLevel,
    speakingSource: pickSource(profile.speakingSource, speakingLevel),
    interests: pickList(profile.interests, MATERIAL_TOPICS),
    goals: pickList(profile.goals, LEARNING_GOALS)
  }
}

export function hasProfile(profile) {
  const normalized = normalizeProfile(profile)
  return Boolean(normalized.listeningLevel || normalized.speakingLevel || normalized.interests.length || normalized.goals.length)
}

// 未登录时填的档案，只在账号上还没有档案时同步上去
export function pickProfileToSync(local, remote) {
  if (hasProfile(remote) || !hasProfile(local)) return null
  return normalizeProfile(local)
}

// 首次引导只给登录用户（里面的定级测试要登录），等账号档案到了再决定，避免已有档案的用户看到引导一闪而过
export function shouldShowOnboarding({ authResolved, loggedIn, userDataReady, hasProfile: profileExists, dismissed }) {
  if (!authResolved || !loggedIn || !userDataReady) return false
  return !profileExists && !dismissed
}
